import * as transferActions from './actions';
import transferEpics from './epics';
import reducer from './reducers';
import * as transferSelectors from './selectors';

export { transferActions, transferEpics, transferSelectors };

export default reducer;
